// extracted by mini-css-extract-plugin
export default {"main":"SocialFooter_main__QiYaK","discover":"SocialFooter_discover__YvDp+","follow":"SocialFooter_follow__bsNv+","blog":"SocialFooter_blog__HnZYN"};